import { grey } from "@mui/material/colors";

const styles = {
  button: {
    p: 2,
    width: "100%",
    backgroundColor: `${grey[200]}`,
    border: `1px solid ${grey[300]}`,
    borderRadius: 2,
    my: 1,
    cursor: "pointer",
    "&:hover": {
      color: "black",
      backgroundColor: "primary.light",
    },
  },
  active: {
    backgroundColor: "primary.light",
    border: `1px solid ${grey[500]}`,
    color: "black",
  },
  form: {
    minWidth: { xs: "auto", md: 400 },
    my: 1,
  },
  noBorder: {
    ml: { xs: -2, md: 0 },
    fontSize: 12,
    maxWidth: { xs: 350, md: 400 },
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  templateName: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  label: {
    color: "black",
    fontSize: 12,
  },
  createButton: {
    backgroundColor: "primary.main",
    color: "white",
    borderRadius: "12px",
    fontSize: 12,
    px: 1,
    py: 0.5,
  },
};

export default styles;
